<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="bg-success m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60">
            <div class="col-md-6 text-center mx-auto text-white p-b-30">
              <h3 class="h3">Enrollee Uploads CSV</h3>

              <div class="form-dark">
                <div class="input-group input-group-flush mb-3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <a class="btn btn-dark my-3" href="/Sample_Data.xlsx">Download Sample Format</a>
        <div class="row list">
          <div class="col-lg-12 col-md-12">
            <div class="card m-b-30">
              <div class="card card-header">
                <!-- <div class="col-md-3">
                  <label for="">Start Upload From Number?: {{ json_index }}
                  </label>
                  <input type="text" class="form-control" v-model="json_index" />
                </div> -->
                <div class="col-md-12 my-2">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="inputGroupFileAddon01">Upload</span>
                    </div>
                    <div class="custom-file">
                      <input type="file" @change="handleFileUpload" accept=".csv" class="custom-file-input"
                        id="inputGroupFile01" aria-describedby="inputGroupFileAddon01" />
                      <label class="custom-file-label" for="inputGroupFile01">Choose file (Must be CSV)</label>
                    </div>
                  </div>

                  <div v-if="clients.length > 1" class="my-2">
                    <p class="h6">
                      Total to be Uploaded JSON: {{ clients.length }}
                    </p>
                    <p class="h6">{{ this.json_index }} Index Uploaded</p>
                  </div>
                </div>

                <p>
                  <button class="btn btn-dark btn-block" @click="bulkUpload">
                    Submit
                  </button>
                </p>
              </div>

              <div class="card-body">
                <div class="table-responsive">
                  <div class="col-md-12">
                    <b-table striped hover :items="clients"></b-table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="vld-parent">
            <loading :active.sync="isLoading" loader="dots" :can-cancel="false" :is-full-page="fullPage"></loading>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";

  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  // Init plugin
  import Papa from "papaparse";

  export default {
    components: {
      Loading,
      Navbar,
    },
    data() {
      return {
        isLoading: false,
        fullPage: true,
        states: "",
        clients: "",
        gender: "",
        value_list: "",
        auto_selected: "",
        json_index: 0,
      };
    },
    computed: {
      //
    },

    methods: {
      onFileChange(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        this.readFile(files[0]);
      },
      readFile(file) {
        let reader = new FileReader();
        reader.onload = (e) => {
          console.log(e.target.result);
          this.clients = JSON.parse(e.target.result);
        };
        reader.readAsText(file);
      },

      //papaParse Functions
      async handleFileUpload(event) {
        const file = event.target.files[0];
        try {
          const jsonData = await this.parseCSVtoJSON(file);
          console.log(jsonData);
          this.clients = jsonData;
        } catch (error) {
          console.error(error);
        }
      },

      async parseCSVtoJSON(file) {
        return new Promise((resolve, reject) => {
          Papa.parse(file, {
            header: true,
            complete: (result) => {
              resolve(result.data);
            },
            error: (error) => {
              reject(error);
            },
          });
        });
      },
      //End of papaParse Functions

      async bulkUpload() {
        this.isLoading = true;

        try {
          this.user = JSON.parse(localStorage.getItem("user")) || {};


          const payload = {
            agency_id: 95930,
            data: this.clients,
          };

          const response = await this.axios.post(
            "/api/v1/auth/multiverse/add",
            payload
          );

          console.log(response.data);

          this.$toasted.success("Submitted successfully!", {
            position: "top-center",
            duration: 3000,
          });
        } catch (error) {
          console.error(error);
          this.$toasted.error("Request failed!", {
            position: "top-center",
            duration: 3000,
          });
        } finally {
          this.isLoading = false;
        }
      }


    },
    created() { },
  };
</script>